import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Alert
} from '@mui/material';
import { useAddContractForm } from './hooks';
import { AddContractButton, ContractFormFields, DialogActionButtons } from './components';

const AddContractDialog: React.FC = () => {
    const {
        open,
        error,
        contract,
        isLoading,
        isFormValid,
        handleOpen,
        handleClose,
        handleSave
    } = useAddContractForm();

    return (
        <>
            <AddContractButton onClick={handleOpen} />

            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                    }
                }}
            >
                <DialogTitle sx={{ pb: 1 }}>
                    <Typography variant="h5" component="div" sx={{ fontWeight: 600, color: '#1e293b' }}>
                        Add New Contract
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        Enter the basic contract information to get started
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ pt: 3 }}>
                    {error && (
                        <Alert severity="error" sx={{ mb: 3 }}>
                            {error}
                        </Alert>
                    )}

                    {contract ? (
                        <ContractFormFields />
                    ) : (
                        <Typography variant="body1" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                            Initializing form...
                        </Typography>
                    )}
                </DialogContent>

                <DialogActionButtons
                    isLoading={isLoading}
                    isFormValid={isFormValid}
                    onCancel={handleClose}
                    onSave={handleSave}
                />
            </Dialog>
        </>
    );
};

export default AddContractDialog;
